import { isCoordinatePair } from '../../../utils/utils';

export const getPolygon = polygon => {
  if (!window.ymaps || !polygon) return null;
  const { coordinates, property = {} } = polygon;
  const {
    name, color, id, zIndex,
  } = property;
  return new window.ymaps.Polygon(coordinates || [], {
    hintContent: name || 'Зона',
    id: id || Math.random().toString(36).substr(2, 10),
  }, {
    editorDrawingCursor: 'crosshair',
    fillColor: color || '#00FF0050',
    strokeColor: '#1665A720',
    strokeWidth: 1,
    zIndex: zIndex || 1,
  });
};

export const getPlacemark = placemark => {
  if (!window.ymaps || !placemark) return null;
  const { location, option = {} } = placemark;
  if (!isCoordinatePair(location?.coordinates)) {
    return null;
  }
  return new window.ymaps.Placemark([location.coordinates[1], location.coordinates[0]], option, {
    preset: 'islands#greenDotIconWithCaption',
  });
};
